var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex"},[_c('div',{staticClass:"denglu"},[(_vm.topType)?_c('nav-footer',{ref:"dingbu",on:{"qiehuan":_vm.yuyan}}):_vm._e(),_c('router-view',{ref:"routerView",staticClass:"yangshi",attrs:{"parentPrint":_vm.parentPrint}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }